import {
    Badge,
    Box,
    Button,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import { faSpinnerThird, faTimeline } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useMemo } from 'react';

import CampaignEventsTable from '../../campaignEvents/CampaignEventsTable';
import { CustomMultiSelect } from '../../../../common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAvailableAgents } from '../../../../../http/apiClient';
import useCampaignAction from '../../../../../http/mutations/campaigns/useCampaignAction';
import { useForm } from '@mantine/form';

const renderMultiSelectOption = ({ option, queryData }) => {
    const dto = queryData;
    if (!dto) {
        return <></>;
    }

    const agentName = dto.subName
        ? `${dto.name}-${dto.subName.replace('usb-', '')}`
        : dto.name;

    return (
        <Group gap='sm'>
            <div>
                <Text size='sm'>
                    {agentName}{' '}
                    {dto.available ? (
                        <Badge
                            size={'xs'}
                            color={'teal.6'}>
                            Available
                        </Badge>
                    ) : (
                        <Badge
                            size={'xs'}
                            color={'red.6'}>
                            {dto.assignment?.campaignName}
                        </Badge>
                    )}
                </Text>
                {dto.assignment ? (
                    <Text
                        size='xs'
                        opacity={0.7}>
                        Campaign: {dto.assignment?.campaignName}
                    </Text>
                ) : null}
            </div>
        </Group>
    );
};

const CampaignStartModal = ({ campaign, openTab, opened, close }) => {
    const defaultAgents = useMemo(() => {
        return (
            campaign?.assignments?.map((x) => ({
                label: x.agentName,
                value: x.agentId.toString(),
            })) || null
        );
    }, [campaign?.assignments]);

    const getInitialValues = () => ({
        id: campaign?.id,
        action: 'Enqueue',
        agentIds: defaultAgents?.map((x) => x.value) || [],
        dataManagerType: 'default',
    });
    const form = useForm({
        initialValues: getInitialValues(),

        validate: {
            agentIds: (value) => {
                if (!value) {
                    return 'Select at least one agent';
                }
            },
            /*emailOrUsername: isNotEmpty('Username or email is required'),
                    password: (val) =>
                        val.length <= 6
                            ? 'Password should include at least 6 characters'
                            : null,*/
        },
    });

    useEffect(() => {
        form.setInitialValues(getInitialValues());
        form.reset();
    }, [opened]);

    const { isPending, mutate: campaignAction } = useCampaignAction();

    const onSubmit = ({ id, ...model }) => {
        campaignAction(
            { id, model },
            {
                onSuccess: () => {
                    close();
                },
            }
        );
    };

    const dataManagerOptions = [
        {
            label: 'Default',
            value: 'default',
        },
        /*{
            label: 'Timezone-priority',
            value: 'timezone',
        },*/
    ];

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size='lg'>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>
                        {campaign ? `Start ${campaign.name}` : 'Start Campaign'}
                    </Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <Stack gap={'sm'}>
                            <CustomMultiSelect
                                label={'Agents'}
                                placeholder={'Select one or more agents'}
                                withAsterisk
                                queryKey={'campaign_agents'}
                                queryHttpFn={(pagination) =>
                                    getAvailableAgents({
                                        campaignId: campaign?.id,
                                        routeId: campaign.route?.id,
                                        pagination,
                                    })
                                }
                                optionsMapFn={(x) => ({
                                    value: x.id.toString(),
                                    label: x.subName
                                        ? `${x.name}-${x.subName.replace(
                                              'usb-',
                                              ''
                                          )}`
                                        : x.name,
                                    disabled: !x.available,
                                })}
                                defaultValue={defaultAgents}
                                renderOption={renderMultiSelectOption}
                                hidePickedOptions
                                key={form.key('agentIds')}
                                {...form.getInputProps('agentIds')}
                            />

                            <Select
                                label={'Data Manager'}
                                data={dataManagerOptions}
                                withAsterisk
                                key={form.key('dataManagerType')}
                                {...form.getInputProps('dataManagerType')}
                            />

                            <Button
                                type={'submit'}
                                size={'compact-sm'}
                                disabled={!form.isValid() || isPending}
                                rightSection={
                                    isPending ? (
                                        <FontAwesomeIcon
                                            icon={faSpinnerThird}
                                            spin
                                        />
                                    ) : null
                                }>
                                Start
                            </Button>
                        </Stack>
                    </form>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default CampaignStartModal;
